(function() {
  'use strict';

  function injectFAQSchema() {
    // 1. 改为直接查找包含 Q: 和 A: 的 p 标签，这样逻辑更清晰
    const paragraphs = Array.from(document.querySelectorAll('h3, p'));
    const faqData = [];
    
    let tempQuestion = null;

    paragraphs.forEach((p) => {
      const text = p.innerText.trim();
      
      // 匹配 Q 开头的段落
      if (/^Q\d*[:：]/i.test(text)) {
        // 提取问题：去掉开头的 Q: 
        tempQuestion = text.replace(/^Q\d*[:：]\s*/i, '').trim();
      } 
      // 匹配 A 开头的段落，且当前已经存有一个待匹配的问题
      else if (/^A\d*[:：]/i.test(text) && tempQuestion) {
        // 提取答案：去掉开头的 A:
        const answerText = text.replace(/^A\d*[:：]\s*/i, '').trim();
        
        if (tempQuestion && answerText) {
          faqData.push({ 
            q: tempQuestion, 
            a: answerText 
          });
          // 清空临时问题，等待下一个 Q
          tempQuestion = null; 
        }
      }
    });

    // 2. 注入 JSON-LD (保持不变)
    if (faqData.length > 0) {
      const old = document.getElementById('faq-schema-injected');
      if (old) old.remove();

      const jsonLd = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqData.map(item => ({
          "@type": "Question",
          "name": item.q,
          "acceptedAnswer": { "@type": "Answer", "text": item.a }
        }))
      };

      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'faq-schema-injected';
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
      
      console.log(`✅ [FAQ SEO] 成功提取 ${faqData.length} 对问答并注入！`, faqData);
    } else {
      console.log("ℹ️ [FAQ SEO] 未能匹配到 Q&A，请检查 HTML 结构。");
    }
  }

  // 执行逻辑
  if (document.readyState === 'complete') {
    setTimeout(injectFAQSchema, 2000); 
  } else {
    window.addEventListener('load', () => setTimeout(injectFAQSchema, 2000));
  }

  // 处理异步切换（如 Tab）
  document.addEventListener('click', (e) => {
    const targetText = e.target.innerText ? e.target.innerText.toLowerCase() : '';
    if (targetText.includes('faq') || e.target.className.includes('tab')) {
      setTimeout(injectFAQSchema, 800);
    }
  });
})();